export default __webpack_public_path__ + "static/media/pictogramBeaconGuarantee128.b2dd9ef6.svg";